import { Button, Stack } from '@chakra-ui/react';

export function Unavailable() {
  return (
    <Stack className="product_unavailable" spacing="2xs">
      <Button isDisabled>Product unavailable</Button>
    </Stack>
  );
}
